import React, { useEffect, useState } from "react";
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin, Tag } from "antd";
import { LinkOutlined } from "@ant-design/icons";
import { getUsers } from "../../Users/services/userApi";
import SelectField from "../../../Components/Common/Form/SelectField";
import "../../Styles/style.css";
import FormField from "../../../Components/Common/Form/FormField";
import { assignMaterial } from "../services/demandeApi";

const AffectDemandeForm = ({ modal, setModal, toggle, selectedDemande }) => {
  const queryClient = useQueryClient();
  const [isLoadingSubmit, setisLoadingSubmit] = useState(false);

  const { isLoading, isError, error, data: users } = useQuery("users", getUsers);
  const intervenant = users?.filter(user => user.role?.name === "INTERVENANT");

  // console.log('selectedDemande =>', selectedDemande)

  const {
    id,
    requestNumber,
    level,
    description,
    filename,
    name,
    createdAt,
    status,
    technician,
    archived,
    address,
    closureDate,
    remiseDate,
    requestFor,
    intervenants,
    suivis,
  } = selectedDemande || {};
  
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowFormatted = tomorrow.toISOString().split("T")[0];

  const validationSchema = Yup.object().shape({
    intervenantId: Yup.string().required("Merci de choisir un intervenant")
  });

  const initialValues = {
    intervenantId : "",
    description: "Merci de prendre en compte cette demande le plus vite possible",
    dateLimit : tomorrowFormatted,
  };
  
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setisLoadingSubmit(true);
      const now = new Date();
      const [year, month, day] = values.dateLimit.split('-');
      const dateWithTime = new Date(year, month - 1, day, now.getHours(), now.getMinutes(), now.getSeconds());
      const data = {
        intervenantId : values?.intervenantId,
        materialRequestId : id,
        description : values?.description,
        dateLimit : dateWithTime.toISOString(),
      }
      
      try {
        await assignMaterial(data);
        toast.success(`La demande a été affectée avec succès 🎉`);
        await queryClient.invalidateQueries("demandes");
        toggle();
        formik.resetForm();
      } catch (error) {
        console.error("Erreur lors de l'affectation :", error?.message || error);
        toast.error("Erreur lors de l'affectation 😌");
      } finally {
        setisLoadingSubmit(false);
      }
    },
  });

  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedDemande]);

  return (
    <Modal
      id="showModalClient"
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop={"static"}
      style={{ maxWidth: "800px" }}
    >
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        <LinkOutlined /> Affecter la demande {requestNumber} à l'intervenant
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
            <Row>
              <FormField label="Demande" name="name" formik={formik} value={name} colSize={6} disabled />
              <FormField label="Technicien" name="description" formik={formik} value={technician?.name} colSize={6} disabled />

              <SelectField
                label="Intervenant"
                name="intervenantId"
                formik={formik}
                isLoading={isLoading}
                isError={isError}
                options={intervenant}
                nameSelect = "l'intervenant"
                error={formik.errors.intervenantId}
                colSize={6}
                isName = {false}
              />
              <FormField label="Date limite" name="dateLimit" formik={formik} colSize={6} type="date"/>
              <FormField label="Description" name="description" formik={formik} colSize={12} isTextarea={true}/>
            </Row>
            
        </ModalBody>

        <ModalFooter>
          <Button color="light" onClick={() => setModal(false)}>
            Annuler
          </Button>
          <Button type="submit" className="active-tab" disabled={isLoadingSubmit}>
            {isLoadingSubmit ? <Spin size="small" /> : "Affecter"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AffectDemandeForm;
